import { useState } from 'react';
import { toast } from 'react-toastify';
import { generateRCAPDF } from '../services/rcaPdfService';

export const useRCAForm = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    reportDate: new Date().toISOString().split('T')[0],
    fault: '',
    locationAffected: '',
    faultDate: '',
    faultTime: '',
    severityLevel: '',
    safetyImpact: '',
    operationalImpact: '',
    serviceImpactDuration: '',
    stakeholdersAffected: '',
    operationalCharacteristics: '',
    supervisoryState: '',
    conclusion: '',
    rootCauseValidation: '',
    recommendations: '',
    faultLog: null,
    images: [], // each item: { file: File, caption: string }
  });

  // Handle text input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  // Handle fault log upload
  const handleFaultLogUpload = (file) => {
    setFormData(prev => ({
      ...prev,
      faultLog: file
    }));
  };

  // Handle image uploads
  const handleImageUpload = (files) => {
    const fileObjects = files.map(f => ({ file: f, caption: '' }));
    setFormData(prev => ({
      ...prev,
      images: [...prev.images, ...fileObjects]
    }));
  };

  // Remove uploaded fault log
  const removeFaultLog = () => {
    setFormData(prev => ({
      ...prev,
      faultLog: null
    }));
  };

  // Remove uploaded image
  const removeImage = (index) => {
    setFormData(prev => ({
      ...prev,
      images: prev.images.filter((_, i) => i !== index)
    }));
  };

  // Update image caption
  const handleImageCaptionChange = (index, caption) => {
    setFormData(prev => ({
      ...prev,
      images: prev.images.map((img, i) => i === index ? { ...img, caption } : img)
    }));
  };

  // Generate PDF
  const generatePDF = async () => {
    try {
      setLoading(true);

      // Validation
      const requiredFields = ['fault', 'locationAffected', 'faultDate', 'faultTime', 'severityLevel', 
        'safetyImpact', 'operationalImpact', 'serviceImpactDuration', 'stakeholdersAffected',
        'operationalCharacteristics', 'supervisoryState', 'conclusion', 'rootCauseValidation',
        'recommendations'];
      const missingFields = requiredFields.filter(field => !formData[field]);
      
      if (missingFields.length > 0) {
        toast.error(`Please fill in all required fields: ${missingFields.join(', ')}`);
        setLoading(false);
        return;
      }

      // Generate PDF
      const pdfBytes = await generateRCAPDF(formData);

      // Download PDF
      const blob = new Blob([pdfBytes], { type: 'application/pdf' });
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = `RCA_${formData.reportDate}.pdf`;
      link.click();

      toast.success('PDF generated successfully!');
      
    } catch (error) {
      console.error('Error generating PDF:', error);
      toast.error('Failed to generate PDF: ' + error.message);
    } finally {
      setLoading(false);
    }
  };

  return {
    formData,
    loading,
    handleChange,
    handleFaultLogUpload,
    handleImageUpload,
    removeFaultLog,
    removeImage,
    handleImageCaptionChange,
    generatePDF
  };
};
